import { NavigatorItem } from "common/components/Navigator/types";
import { List, Map } from "immutable";

export type NavigatorItemGroupKey = "jobTabs" | "orgTabs" | "default" | "orgSettings";

export const navigatorItems = Map<NavigatorItemGroupKey, List<NavigatorItem>>({
  jobTabs: List<NavigatorItem>([
    // Job Tabs
    { kind: "go-to", label: "Information Tab", link: "/jobs/:currentJobId/info" },
    { kind: "go-to", label: "Finance Tab", link: "/jobs/:currentJobId/financing" },
    { kind: "go-to", label: "Inspection Tab", link: "/jobs/:currentJobId/inspection" },
    { kind: "go-to", label: "Appointments Tab", link: "/jobs/:currentJobId/appointments" },
    { kind: "go-to", label: "Tools Tab", link: "/jobs/:currentJobId/tools" },
    { kind: "go-to", label: "Photos Tab", link: "/jobs/:currentJobId/images" },
    { kind: "go-to", label: "Documents Tab", link: "/jobs/:currentJobId/documents" },
    { kind: "go-to", label: "Measurements Tab", link: "/jobs/:currentJobId/measurements" },
    { kind: "go-to", label: "Notes Tab", link: "/jobs/:currentJobId/notes" },
    { kind: "go-to", label: "History Tab", link: "/jobs/:currentJobId/history" },
    { kind: "go-to", label: "Presentations Tab", link: "/jobs/:currentJobId/presentations" },
    { kind: "go-to", label: "Dynamic Presentations", link: "/jobs/:currentJobId/presentations/dynamic" },
    { kind: "go-to", label: "Design Tools Tab", link: "/jobs/:currentJobId/design-tools" },
    { kind: "go-to", label: "Estimates Tab", link: "/jobs/:currentJobId/estimates" },
    { kind: "go-to", label: "Proposals Tab", link: "/jobs/:currentJobId/proposals" },
    { kind: "go-to", label: "Contracts Tab", link: "/jobs/:currentJobId/contracts" },
    { kind: "go-to", label: "Signatures Tab", link: "/jobs/:currentJobId/signatures" },
    // Misc Items
    {
      kind: "go-to",
      label: "Current Organization Settings",
      link: "/orgs/:currentUserOrgId",
    },
    {
      kind: "go-to-search",
      label: "Select Organization Access",
      searchKind: "access",
    },
    {
      kind: "go-to",
      label: "Jobs",
      link: "/jobs",
    },
    {
      kind: "go-to-search",
      label: "Search Job",
      searchKind: "job",
    },
    {
      kind: "go-to-search",
      label: "Search Organization",
      searchKind: "org",
    },
  ]),

  orgTabs: List<NavigatorItem>([
    // Org Tabs
    { kind: "go-to", label: "Information Tab", link: "/orgs/:currentOrgId/info" },
    { kind: "go-to", label: "Child Orgs Tab", link: "/orgs/:currentOrgId/child_orgs" },
    { kind: "go-to", label: "Customers Tab", link: "/orgs/:currentOrgId/jobs" },
    { kind: "go-to", label: "Global Settings Tab", link: "/orgs/:currentOrgId/settings" },
    { kind: "go-to", label: "Analytics Tab", link: "/orgs/:currentOrgId/analytics" },
    { kind: "go-to", label: "Estimator Tab", link: "/orgs/:currentOrgId/estimator" },
    { kind: "go-to", label: "Measurements Tab", link: "/orgs/:currentOrgId/measurements" },
    { kind: "go-to", label: "Documents Tab", link: "/orgs/:currentOrgId/documents" },
    { kind: "go-to", label: "Presentations Tab", link: "/orgs/:currentOrgId/presentations" },
    { kind: "go-to", label: "Financing Tab", link: "/orgs/:currentOrgId/financing" },
    { kind: "go-to", label: "Tools Tab", link: "/orgs/:currentOrgId/tools" },
    { kind: "go-to", label: "Sharing Tab", link: "/orgs/:currentOrgId/sharing" },
    { kind: "go-to", label: "Users Tab", link: "/orgs/:currentOrgId/users" },
    { kind: "go-to", label: "Job Statuses Tab", link: "/orgs/:currentOrgId/job_statuses" },
    { kind: "go-to", label: "Access Management Tab", link: "/orgs/:currentOrgId/access_management" },
    { kind: "go-to", label: "Integrations Tab", link: "/orgs/:currentOrgId/integrations" },
    { kind: "go-to", label: "Products Tab", link: "/orgs/:currentOrgId/products" },
    { kind: "go-to", label: "Webhooks Tab", link: "/orgs/:currentOrgId/webhooks" },
    // Misc Items
    {
      kind: "go-to",
      label: "Billing Info",
      link: "/orgs/:currentUserOrgId/info#billing-info",
    },
    {
      kind: "go-to-search",
      label: "Select Organization Access",
      searchKind: "access",
    },
    {
      kind: "go-to-search",
      label: "Search Job",
      searchKind: "job",
    },
    {
      kind: "go-to-search",
      label: "Search Organization",
      searchKind: "org",
    },
    {
      kind: "go-to",
      label: "Jobs",
      link: "/jobs",
    },
  ]),

  orgSettings: List<NavigatorItem>([
    // Global Settings
    {
      kind: "go-to-setting",
      label: "Titles",
      link: "/orgs/:currentOrgId/settings#titles",
    },
    {
      kind: "go-to-setting",
      label: "Agreement Title",
      link: "/orgs/:currentOrgId/settings#titles#agreement-title",
    },
    {
      kind: "go-to-setting",
      label: "Proposal Title",
      link: "/orgs/:currentOrgId/settings#titles#proposal-title",
    },
    {
      kind: "go-to-setting",
      label: "Inspection Title",
      link: "/orgs/:currentOrgId/settings#titles#inspection-title",
    },
    {
      kind: "go-to-setting",
      label: "Sale Rep. Title",
      link: "/orgs/:currentOrgId/settings#titles#sale-rep.-title",
    },
    {
      kind: "go-to-setting",
      label: "Estimate Title",
      link: "/orgs/:currentOrgId/settings#titles#estimate-title",
    },
    {
      kind: "go-to-setting",
      label: "Opening Name",
      link: "/orgs/:currentOrgId/settings#titles#opening-name",
    },
    {
      kind: "go-to-setting",
      label: "Agreement Title Short",
      link: "/orgs/:currentOrgId/settings#titles#agreement-title-short",
    },
    {
      kind: "go-to-setting",
      label: "Proposal Title Short",
      link: "/orgs/:currentOrgId/settings#titles#proposal-title-short",
    },
    {
      kind: "go-to-setting",
      label: "Inspection Title Short",
      link: "/orgs/:currentOrgId/settings#titles#inspection-title-short",
    },
    {
      kind: "go-to-setting",
      label: "Estimate Title",
      link: "/orgs/:currentOrgId/settings#titles#estimate-title",
    },
    {
      kind: "go-to-setting",
      label: "Price Presentation Title",
      link: "/orgs/:currentOrgId/settings#titles#price-presentation-title",
    },
    {
      kind: "go-to-setting",
      label: "Alerts and Notifications",
      link: "/orgs/:currentOrgId/settings#alerts-and-notifications",
    },
    {
      kind: "go-to-setting",
      label: "Customer Facing Email Settings",
      link: "/orgs/:currentOrgId/settings#customer-facing-email-settings",
    },
    {
      kind: "go-to-setting",
      label: "Job List Configuration",
      link: "/orgs/:currentOrgId/settings#job-list-configuration",
    },
    {
      kind: "go-to-setting",
      label: "Job Types",
      link: "/orgs/:currentOrgId/settings#job-types",
    },
    {
      kind: "go-to-setting",
      label: "Job Menu Configuration",
      link: "/orgs/:currentOrgId/settings#job-menu-configuration",
    },
    {
      kind: "go-to-setting",
      label: "Time Zone",
      link: "/orgs/:currentOrgId/settings#general-settings",
    },
    {
      kind: "go-to-setting",
      label: "Enable Job Note Editing",
      link: "/orgs/:currentOrgId/settings#general-settings",
    },
    {
      kind: "go-to-setting",
      label: "Enable Dynamic Presentations",
      link: "/orgs/:currentOrgId/settings#general-settings",
    },
    {
      kind: "go-to-setting",
      label: "Report Email Preferences",
      link: "/orgs/:currentOrgId/settings#report-email-preferences",
    },
    {
      kind: "go-to-setting",
      label: "Job Resulting Configuration",
      link: "/orgs/:currentOrgId/settings#job-resulting",
    },

    // Estimator Settings
    {
      kind: "go-to-setting",
      label: "Sales Tax",
      link: "/orgs/:currentOrgId/estimator#sales-tax",
    },
    {
      kind: "go-to-setting",
      label: "Pricing Detail",
      link: "/orgs/:currentOrgId/estimator#pricing-detail",
    },
    {
      kind: "go-to-setting",
      label: "Show Detailed Measurements",
      link: "/orgs/:currentOrgId/estimator#pricing-detail",
    },
    {
      kind: "go-to-setting",
      label: "Option Group on Agreement",
      link: "/orgs/:currentOrgId/estimator#pricing-detail",
    },
    {
      kind: "go-to-setting",
      label: "Pricing in Line Item Editor",
      link: "/orgs/:currentOrgId/estimator#pricing-detail",
    },
    {
      kind: "go-to-setting",
      label: "Show Option Total",
      link: "/orgs/:currentOrgId/estimator#pricing-detail",
    },
    {
      kind: "go-to-setting",
      label: "Show Discount and Payment Estimator",
      link: "/orgs/:currentOrgId/estimator#pricing-detail",
    },
    {
      kind: "go-to-setting",
      label: "Show Payment Estimator",
      link: "/orgs/:currentOrgId/estimator#pricing-detail",
    },
    {
      kind: "go-to-setting",
      label: "Estimator Settings",
      link: "/orgs/:currentOrgId/estimator#general-settings",
    },
    {
      kind: "go-to-setting",
      label: "Enable Window Estimator",
      link: "/orgs/:currentOrgId/estimator#general-settings#window-estimator",
    },
    {
      kind: "go-to-setting",
      label: "Enable Full Estimator",
      link: "/orgs/:currentOrgId/estimator#general-settings#full-estimator",
    },
    {
      kind: "go-to-setting",
      label: "Enable Multiple Groups",
      link: "/orgs/:currentOrgId/estimator#general-settings#multiple-groups",
    },
    {
      kind: "go-to-setting",
      label: "Show Product Importer File Uploads",
      link: "/orgs/:currentOrgId/estimator#general-settings",
    },
    {
      kind: "go-to-setting",
      label: "Show Estimated Dates",
      link: "/orgs/:currentOrgId/estimator#general-settings",
    },
    {
      kind: "go-to-setting",
      label: "Show Product Selector on New Estimate",
      link: "/orgs/:currentOrgId/estimator#general-settings",
    },
    {
      kind: "go-to-setting",
      label: "Estimate List Pricing",
      link: "/orgs/:currentOrgId/estimator#general-settings",
    },
    {
      kind: "go-to-setting",
      label: "Add Products Flow",
      link: "/orgs/:currentOrgId/estimator#general-settings",
    },
    {
      kind: "go-to-setting",
      label: "Markup Pricing",
      link: "/orgs/:currentOrgId/estimator#markup-pricing",
    },
    {
      kind: "go-to-setting",
      label: "Commission",
      link: "/orgs/:currentOrgId/estimator#commission",
    },

    // Measurements Settings
    {
      kind: "go-to-setting",
      label: "Measurement Units: Imperial",
      link: "/orgs/:currentOrgId/measurements#measurement-settings#imperial",
    },
    {
      kind: "go-to-setting",
      label: "Measurement Units: Metric",
      link: "/orgs/:currentOrgId/measurements#measurement-settings#metric",
    },
    {
      kind: "go-to-setting",
      label: "Job Measurement Tabs",
      link: "/orgs/:currentOrgId/measurements#measurement-settings",
    },
    {
      kind: "go-to-setting",
      label: "Job Measurement Tabs: Roofing",
      link: "/orgs/:currentOrgId/measurements#measurement-settings#roofing",
    },
    {
      kind: "go-to-setting",
      label: "Job Measurement Tabs: Siding",
      link: "/orgs/:currentOrgId/measurements#measurement-settings#siding",
    },
    {
      kind: "go-to-setting",
      label: "Job Measurement Tabs: Windows",
      link: "/orgs/:currentOrgId/measurements#measurement-settings#windows",
    },
    {
      kind: "go-to-setting",
      label: "Job Measurement Tabs: Doors",
      link: "/orgs/:currentOrgId/measurements#measurement-settings#doors",
    },
    {
      kind: "go-to-setting",
      label: "Job Measurement Tabs: Roof Faces",
      link: "/orgs/:currentOrgId/measurements#measurement-settings#roof-faces",
    },
    {
      kind: "go-to-setting",
      label: "Job Measurement Tabs: Walls",
      link: "/orgs/:currentOrgId/measurements#measurement-settings#walls",
    },
    {
      kind: "go-to-setting",
      label: "Job Measurement Tabs: Fencing",
      link: "/orgs/:currentOrgId/measurements#measurement-settings#fencing",
    },
    {
      kind: "go-to-setting",
      label: "Job Measurement Tabs: Sunroom",
      link: "/orgs/:currentOrgId/measurements#measurement-settings#sunroom",
    },
    {
      kind: "go-to-setting",
      label: "Job Measurement Tabs: Rooms",
      link: "/orgs/:currentOrgId/measurements#measurement-settings#rooms",
    },
    {
      kind: "go-to-setting",
      label: "Job Measurement Tabs: Decks",
      link: "/orgs/:currentOrgId/measurements#measurement-settings#decks",
    },
    {
      kind: "go-to-setting",
      label: "Job Measurement Tabs: Pools",
      link: "/orgs/:currentOrgId/measurements#measurement-settings#pools",
    },

    {
      kind: "go-to-setting",
      label: "Measurement Tools: Window-inator",
      link: "/orgs/:currentOrgId/measurements#measurement-settings#windowinator",
    },
    {
      kind: "go-to-setting",
      label: "Measurement Tools: Siding-inator",
      link: "/orgs/:currentOrgId/measurements#measurement-settings#sidinginator",
    },
    {
      kind: "go-to-setting",
      label: "Measurement Tools: Opening Measuring",
      link: "/orgs/:currentOrgId/measurements#measurement-settings#opening-measuring",
    },
    {
      kind: "go-to-setting",
      label: "Measurement Tools: Rapid Area",
      link: "/orgs/:currentOrgId/measurements#measurement-settings#rapid-area",
    },
    {
      kind: "go-to-setting",
      label: "Measurement Tools: Satellite Measure",
      link: "/orgs/:currentOrgId/measurements#measurement-settings#satellite-measure",
    },
    {
      kind: "go-to-setting",
      label: "Measurement Tools: Fencing Measurement Tool",
      link: "/orgs/:currentOrgId/measurements#measurement-settings#fencing-measurement-tool",
    },
    {
      kind: "go-to-setting",
      label: "Line Item Editor: Display Roofing",
      link: "/orgs/:currentOrgId/measurements#measurement-settings#roofing",
    },
    {
      kind: "go-to-setting",
      label: "Line Item Editor: Display Siding",
      link: "/orgs/:currentOrgId/measurements#measurement-settings#siding",
    },
    {
      kind: "go-to-setting",
      label: "Line Item Editor: Display Windows",
      link: "/orgs/:currentOrgId/measurements#measurement-settings#windows",
    },
    {
      kind: "go-to-setting",
      label: "Line Item Editor: Display Doors",
      link: "/orgs/:currentOrgId/measurements#measurement-settings#doors",
    },
    {
      kind: "go-to-setting",
      label: "Line Item Editor: Display Roof Faces",
      link: "/orgs/:currentOrgId/measurements#measurement-settings#roof-faces",
    },
    {
      kind: "go-to-setting",
      label: "Line Item Editor: Display Walls",
      link: "/orgs/:currentOrgId/measurements#measurement-settings#walls",
    },
    {
      kind: "go-to-setting",
      label: "Line Item Editor: Display Fencing",
      link: "/orgs/:currentOrgId/measurements#measurement-settings#fencing",
    },
    {
      kind: "go-to-setting",
      label: "Line Item Editor: Display Sunroom",
      link: "/orgs/:currentOrgId/measurements#measurement-settings#sunroom",
    },
    {
      kind: "go-to-setting",
      label: "Line Item Editor: Display Rooms",
      link: "/orgs/:currentOrgId/measurements#measurement-settings#rooms",
    },
    {
      kind: "go-to-setting",
      label: "Line Item Editor: Display Decks",
      link: "/orgs/:currentOrgId/measurements#measurement-settings#decks",
    },
    {
      kind: "go-to-setting",
      label: "Line Item Editor: Display Pools",
      link: "/orgs/:currentOrgId/measurements#measurement-settings#pools",
    },
    {
      kind: "go-to-setting",
      label: "Measurements: Levels",
      link: "/orgs/:currentOrgId/measurements#levels",
    },
    {
      kind: "go-to-setting",
      label: "Measurements: Locations",
      link: "/orgs/:currentOrgId/measurements#locations",
    },

    // Documents Settings
    {
      kind: "go-to-setting",
      label: "Document Layout: Inspection",
      link: "/orgs/:currentOrgId/documents/layout#inspection-documents",
    },
    {
      kind: "go-to-setting",
      label: "Document Layout: Proposal",
      link: "/orgs/:currentOrgId/documents/layout#proposal-documents",
    },
    {
      kind: "go-to-setting",
      label: "Document Layout: Agreement",
      link: "/orgs/:currentOrgId/documents/layout#agreement-documents",
    },
    {
      kind: "go-to-setting",
      label: "Enable Required PDF Fields",
      link: "/orgs/:currentOrgId/documents/layout#required-pdf-field-configuration",
    },
    {
      kind: "go-to-setting",
      label: "Document: Cover Page Layout",
      link: "/orgs/:currentOrgId/documents/configuration#cover-page-layout",
    },
    {
      kind: "go-to-setting",
      label: "Contract Language",
      link: "/orgs/:currentOrgId/documents/configuration#contract-language",
    },
    {
      kind: "go-to-setting",
      label: "Document: Estimate PDF Layout",
      link: "/orgs/:currentOrgId/documents/configuration#estimate-pdf-layout",
    },
    {
      kind: "go-to-setting",
      label: "Document: Estimate Pattern",
      link: "/orgs/:currentOrgId/documents/configuration#estimate-pdf-layout",
    },
    {
      kind: "go-to-setting",
      label: "Document: Product Images Pattern",
      link: "/orgs/:currentOrgId/documents/configuration#product-images-layout",
    },
    {
      kind: "go-to-setting",
      label: "Document: Job Images Pattern",
      link: "/orgs/:currentOrgId/documents/configuration#job-images-layout",
    },
    {
      kind: "go-to-setting",
      label: "Document: Commission Pattern",
      link: "/orgs/:currentOrgId/documents/configuration#commission-layout",
    },
    {
      kind: "go-to-setting",
      label: "Document: Cost Pattern",
      link: "/orgs/:currentOrgId/documents/configuration#cost-layout",
    },
    {
      kind: "go-to-setting",
      label: "Document: Labor Summary Pattern",
      link: "/orgs/:currentOrgId/documents/configuration#cost-layout",
    },
    {
      kind: "go-to-setting",
      label: "Document: Presentation Pattern",
      link: "/orgs/:currentOrgId/documents/configuration#presentation-layout",
    },
    {
      kind: "go-to-setting",
      label: "Document: Inspection Slide Pattern",
      link: "/orgs/:currentOrgId/documents/configuration#presentation-layout",
    },
    {
      kind: "go-to-setting",
      label: "Document: Inspection Results Pattern",
      link: "/orgs/:currentOrgId/documents/configuration#inspection-layout",
    },
    {
      kind: "go-to-setting",
      label: "Document: Inspection PDF Pattern",
      link: "/orgs/:currentOrgId/documents/configuration#inspection-layout",
    },
    {
      kind: "go-to-setting",
      label: "Document: Link Expiration",
      link: "/orgs/:currentOrgId/documents/configuration#document-link-expiration",
    },
    {
      kind: "go-to-setting",
      label: "Document Signature Settings",
      link: "/orgs/:currentOrgId/documents/signature#signature",
    },
    {
      kind: "go-to-setting",
      label: "Document Patterns (List)",
      link: "/orgs/:currentOrgId/documents/patterns",
    },

    // Financing & Pricing Settings
    {
      kind: "go-to-setting",
      label: "Price Presentation Settings",
      link: "/orgs/:currentOrgId/financing#price-presentation",
    },
    {
      kind: "go-to-setting",
      label: "Price Presentation: Description Title",
      link: "/orgs/:currentOrgId/financing#price-presentation#description-title",
    },
    {
      kind: "go-to-setting",
      label: "Price Presentation: Investment Options Title",
      link: "/orgs/:currentOrgId/financing#price-presentation#investment-options-title",
    },
    {
      kind: "go-to-setting",
      label: "Price Presentation: Total Title",
      link: "/orgs/:currentOrgId/financing#price-presentation#total-title",
    },
    {
      kind: "go-to-setting",
      label: "Price Presentation: Investment Title",
      link: "/orgs/:currentOrgId/financing#price-presentation#investment-title",
    },
    {
      kind: "go-to-setting",
      label: "Price Presentation: Subtotal Title",
      link: "/orgs/:currentOrgId/financing#price-presentation#subtotal-title",
    },
    {
      kind: "go-to-setting",
      label: "Price Comparison Settings",
      link: "/orgs/:currentOrgId/financing#price-comparison",
    },
    {
      kind: "go-to-setting",
      label: "Finance Options",
      link: "/orgs/:currentOrgId/financing#finance-options",
    },
    {
      kind: "go-to-setting",
      label: "Discounts",
      link: "/orgs/:currentOrgId/financing#discounts",
    },
    {
      kind: "go-to-setting",
      label: "Payment Terms",
      link: "/orgs/:currentOrgId/financing#payment-terms",
    },

    // Tools
    {
      kind: "go-to-setting",
      label: "Tools (List)",
      link: "/orgs/:currentOrgId/tools#tools",
    },
    {
      kind: "go-to-setting",
      label: "Design Tools",
      link: "/orgs/:currentOrgId/tools#design-tools",
    },
    {
      kind: "go-to-setting",
      label: "Reports",
      link: "/orgs/:currentOrgId/tools#reports",
    },

    // Sharing
    {
      kind: "go-to-setting",
      label: "Screen Share Kind",
      link: "/orgs/:currentOrgId/sharing#general-settings#basic",
    },
    {
      kind: "go-to-setting",
      label: "Survey URL",
      link: "/orgs/:currentOrgId/sharing#general-settings#survey-url",
    },
    {
      kind: "go-to-setting",
      label: "Screenleap / Screenshare Settings",
      link: "/orgs/:currentOrgId/sharing#general-settings",
    },

    // Access Management
    {
      kind: "go-to-setting",
      label: "Access Management: Tools",
      link: "/orgs/:currentOrgId/access_management#tools",
    },
    {
      kind: "go-to-setting",
      label: "Access Management: Design Tools",
      link: "/orgs/:currentOrgId/access_management#design-tools",
    },
    {
      kind: "go-to-setting",
      label: "Access Management: Reports",
      link: "/orgs/:currentOrgId/access_management#reports",
    },
    {
      kind: "go-to-setting",
      label: "Access Management: Job Menu Configuration",
      link: "/orgs/:currentOrgId/access_management#job-menu-configuration",
    },
    {
      kind: "go-to-setting",
      label: "Access Management: Visualizations",
      link: "/orgs/:currentOrgId/access_management#visualizations",
    },
    {
      kind: "go-to-setting",
      label: "Access Management: Price Presentation",
      link: "/orgs/:currentOrgId/access_management#price-presentation-and-comparison#enable-price-presentation",
    },
    {
      kind: "go-to-setting",
      label: "Access Management: Price Comparison",
      link: "/orgs/:currentOrgId/access_management#price-presentation-and-comparison#enable-price-comparison",
    },
    {
      kind: "go-to-setting",
      label: "Dashboard Communication URL",
      link: "/orgs/:currentOrgId/access_management#general-settings#dashboard-communication-url",
    },
    {
      kind: "go-to-setting",
      label: "Access Management: Document Link Expiration",
      link: "/orgs/:currentOrgId/access_management#general-settings#default-time-periods-cannot-be-overridden",
    },
    {
      kind: "go-to-setting",
      label: "Access Management: Estimator - Window Estimator",
      link: "/orgs/:currentOrgId/access_management#estimator-settings#window-estimator",
    },
    {
      kind: "go-to-setting",
      label: "Access Management: Estimator - Full Estimator",
      link: "/orgs/:currentOrgId/access_management#estimator-settings#full-estimator",
    },
    {
      kind: "go-to-setting",
      label: "Access Management: Estimator - Multiple Groups",
      link: "/orgs/:currentOrgId/access_management#estimator-settings#multiple-groups",
    },
    {
      kind: "go-to-setting",
      label: "Access Management: Estimator - Interiors",
      link: "/orgs/:currentOrgId/access_management#estimator-settings#interiors",
    },
    {
      kind: "go-to-setting",
      label: "Access Management: Estimator - Calculation Method",
      link: "/orgs/:currentOrgId/access_management#estimator-settings#default",
    },
    {
      kind: "go-to-setting",
      label: "Access Management: Modules",
      link: "/orgs/:currentOrgId/access_management#modules-configuration",
    },
  ]),

  default: List<NavigatorItem>([
    // Misc Items
    {
      kind: "go-to",
      label: "Current Organization Settings",
      link: "/orgs/:currentUserOrgId",
    },
    {
      kind: "go-to-search",
      label: "Select Organization Access",
      searchKind: "access",
    },
    {
      kind: "go-to-search",
      label: "Search Job",
      searchKind: "job",
    },
    {
      kind: "go-to-search",
      label: "Search Organization",
      searchKind: "org",
    },
    {
      kind: "go-to",
      label: "Jobs",
      link: "/jobs",
    },
  ]),
});
